import React, { useState } from 'react';
import MainImage from '../../images/portfolio/JetRunner/video-thumbnail.png';
import Artwork from '../../images/portfolio/JetRunner/artwork.png'
import Artwork2 from '../../images/portfolio/JetRunner/artwork-2.png'
import PortfolioPage from '../../components/PortfolioPage';
import { useT } from '../../i18n';

const Jetrunner = () => {
  const t = useT();
  return <PortfolioPage
    img={MainImage}
    url="https://www.youtube.com/embed/KIEupe-paj8?si=MBcCUeZFvB8h-x"
    title="Jetrunner"
    description={t(`
          Det trønderske spillselskapet Riddlebit, ønsket å slå seg sammen med oss i The Branch for å promotere
          det nye PC-spillet, Jetrunner. Formålet ble å lage noe engasjerende og actionfylt som skulle understreke
          opplevelsene man får av å spille spillet. Oppgavene var å lage storyboard, animatic, bakgrunner og animasjon.
          I det 46 sekunders lange sluttproduktet, blir alle de seks originale levelene i spillet representert.
        `, `
          Riddlebit, a game studio from Trøndelag, teamed up with us at The Branch to promote their new PC game,
          Jetrunner. The goal was to make something engaging and action-packed that captured the experience of
          playing the game. We handled the storyboard, animatic, backgrounds and animation.
          All six original levels of the game appear in the 46-second final film.
        `)}
  >
    <div className="flex  justify-center mt-32 lg:px-0 flex-wrap mb-12">
      <div>
        <img src={Artwork} />
        <img className="mt-32" src={Artwork2} />
      </div>
    </div>
  </PortfolioPage>

}

export default Jetrunner;
